import { Injectable, Injector } from "@angular/core";
import { DataPropGroup, FrameContext } from "@farris/devkit";

@Injectable()
export class PaginationService {
  constructor(private injector: Injector, private frameContext: FrameContext) { }
  /**
   * éç½®å­è¡¨åé¡µä¿¡æ¯
   */
  public resetChildrenPagination() {
    const paginationInfo = this.frameContext.repository.entityCollection.paginationInfo || {};
    const childrenEntityCodes = this.frameContext.repository.entityTypeInfo.getPropNamesByGroup(DataPropGroup.List) || [];
    if (paginationInfo && Object.keys(paginationInfo).length > 0) {
      const keys = Object.keys(paginationInfo);
      keys.forEach((key: string) => {
        const value = paginationInfo[key];
        if (Object.prototype.toString.apply(value) !== '[object Object]') {
          return;
        }
        const rowPagination = childrenEntityCodes.find((nodeCode: string) => {
          // å»æs
          nodeCode = nodeCode.slice(0, -1);
          return key.startsWith(`${nodeCode}_`);
        });
        if (rowPagination) {
          delete paginationInfo[key];
        } else {
          paginationInfo[key].pageIndex = 1;
          delete paginationInfo[key].total;
          delete paginationInfo[key].pageCount;
        }
      });
      this.frameContext.repository.entityCollection.updatePaginationInfoByPath('/', paginationInfo);
    }
  }
}